import Reflux from "reflux";
import { singletonActions } from "logic/singleton";
const GroupSynchronizationActions = singletonActions(
  "enterprise.authentication.directoryService.GroupSync",
  () => Reflux.createActions({
    create: { asyncResult: true },
    delete: { asyncResult: true },
    load: { asyncResult: true },
    loadGroups: { asyncResult: true },
    update: { asyncResult: true }
  })
);
export default GroupSynchronizationActions;
